



























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Data, ColorSets, Foregrounds, Backgrounds } from './Meta';
import TSampler from './TSampler.vue';
import CSampler from './CSampler.vue';

@Component({
  components: {
    TSampler,
    CSampler
  }
})
export default class Canvas extends Vue {
  container: HTMLElement|null = null;
  canvas: HTMLCanvasElement|null = null;
  context: CanvasRenderingContext2D|null = null;

  previewCanvas: HTMLCanvasElement|null = null;
  previewContext: CanvasRenderingContext2D|null = null;
  hiddenCanvas: HTMLCanvasElement|null = null;
  hiddenContext: CanvasRenderingContext2D|null = null;


  featerWidth = 1024.0;
  featerHeight = 500.0;

  @Prop({ default: new Data() })
  data!: Data;
  @Watch("data", { deep: true })
  onDataChange() {
      this.resize();
  }

  aligns = ["left", "center", "right"];

  mounted() {
    this.container = document.getElementById('container');
    this.previewCanvas = document.getElementById('canvas') as HTMLCanvasElement;
    this.previewCanvas.width = this.featerWidth;
    this.previewCanvas.height = this.featerHeight;
    this.previewContext = this.previewCanvas.getContext('2d');
    this.hiddenCanvas = document.getElementById('_canvas') as HTMLCanvasElement;
    this.hiddenCanvas.width = this.featerWidth;
    this.hiddenCanvas.height = this.featerHeight;
    this.hiddenContext = this.hiddenCanvas.getContext('2d');

    // setInterval(() => {
      this.resize();
    // }, 1000/60);
  }

  scale = 1.0;
  previewScale = 1.0;
  resize() {
    if (this.container == null) return;

    this.previewScale = Math.min(
      (0.0 + this.container.clientWidth - 24) / this.featerWidth,  (0.0 + this.container.clientHeight - 24) / this.featerHeight
    );

    this.scale = this.previewScale;
    this.canvas = this.previewCanvas!!;
    this.canvas.width = this.featerWidth * this.scale;
    this.canvas.height = this.featerHeight * this.scale;
    this.context = this.previewContext;
    this.redraw(true);

    
    this.scale = 1.0;
    this.canvas = this.hiddenCanvas;
    this.context = this.hiddenContext;
    this.redraw(false);
  }

  redraw(first: boolean) {
    const colorSet = this.currentColorSet();
    const template = this.currentTemplate();

    if (this.canvas == null || this.context == null || colorSet == null || template == null) return;

    this.context.textBaseline = "middle";

    if (this.data.backgroundKey == 0) {
      this.context.fillStyle = colorSet.background1;
      this.context.fillRect(0, 0, this.canvas.width, this.canvas.height);
    } else if (this.data.backgroundKey == 1) {
      const grad = this.context.createLinearGradient(0, this.canvas.height / 2, this.canvas.width, this.canvas.height / 2);
      grad.addColorStop(0, colorSet.background1);
      grad.addColorStop(1, colorSet.background2);
      this.context.fillStyle = grad;
      this.context.fillRect(0, 0, this.canvas.width, this.canvas.height);
    } else if (this.data.backgroundKey == 2) {
      const grad = this.context.createLinearGradient(this.canvas.width / 2, 0, this.canvas.width / 2, this.canvas.height);
      grad.addColorStop(0, colorSet.background1);
      grad.addColorStop(1, colorSet.background2);
      this.context.fillStyle = grad;
      this.context.fillRect(0, 0, this.canvas.width, this.canvas.height);
    } else if (this.data.backgroundKey == 3) {
      const grad = this.context.createRadialGradient(this.canvas.width / 2, this.canvas.height / 2, 50 * this.scale, this.canvas.width / 2, this.canvas.height / 2, this.canvas.height);
      grad.addColorStop(0, colorSet.background1);
      grad.addColorStop(1, colorSet.background2);
      this.context.fillStyle = grad;
      this.context.fillRect(0, 0, this.canvas.width, this.canvas.height);
      this.context.fill();
    } else if (this.data.backgroundKey == 4) {
      this.context.fillStyle = colorSet.background1;
      this.context.fillRect(0, 0, this.canvas.width, this.canvas.height);
      this.context.fillStyle = colorSet.background2;
      this.context.beginPath();
      this.context.moveTo(this.canvas.width / 2 + 100 * this.scale, 0);
      this.context.lineTo(this.canvas.width, 0);
      this.context.lineTo(this.canvas.width, this.canvas.height);
      this.context.lineTo(this.canvas.width / 2 - 100 * this.scale, this.canvas.height);
      this.context.closePath();
      this.context.fill();
    } else if (this.data.backgroundKey == 5) {
      this.context.fillStyle = colorSet.background1;
      this.context.fillRect(0, 0, this.canvas.width, this.canvas.height);
      this.context.fillStyle = colorSet.background2;
      this.context.beginPath();
      this.context.moveTo(0, this.canvas.height / 2 + 100 * this.scale);
      this.context.lineTo(0, this.canvas.height);
      this.context.lineTo(this.canvas.width, this.canvas.height);
      this.context.lineTo(this.canvas.width, this.canvas.height / 2 - 100 * this.scale);
      this.context.closePath();
      this.context.fill();
    } else if (this.data.backgroundKey == 6) {
      this.context.fillStyle = colorSet.background1;
      this.context.fillRect(0, 0, this.canvas.width, this.canvas.height);
      this.context.fillStyle = colorSet.background2;
      this.context.beginPath();
      this.context.moveTo(this.canvas.width, 0);
      this.context.bezierCurveTo( this.canvas.width / 2, 0, this.canvas.width / 2, this.canvas.height, 0, this.canvas.height );
      this.context.lineTo(this.canvas.width, this.canvas.height);
      this.context.closePath();
      this.context.fill();
    }

    this.context.fillStyle = colorSet.title;
    this.context.font = `${template.titleSize * this.scale}pt ${this.data.font}`;
    this.context.textAlign = template.titleAlign as CanvasTextAlign;
    this.context.fillText(this.data.title, template.titleLeft * this.scale, template.titleTop * this.scale);

    this.context.fillStyle = colorSet.description;
    this.context.font = `${template.descriptionSize * this.scale}pt ${this.data.font}`;
    this.context.textAlign = template.descriptionAlign as CanvasTextAlign;
    this.context.fillText(this.data.description, template.descriptionLeft * this.scale, template.descriptionTop * this.scale);

    if (first) {
      let ss1Path = "";
      if (this.data.ss1Path != null) ss1Path = this.data.ss1Path;
      else ss1Path = require("@/assets/ss.png");
      const ss1Img = new Image();
      ss1Img.src = ss1Path;
      ss1Img.onload = this.ss1OnLoad;

      let ss2Path = "";
      if (this.data.ss2Path != null) ss2Path = this.data.ss2Path;
      else ss2Path = require("@/assets/ss.png");
      const ss2Img = new Image();
      ss2Img.src = ss2Path;
      ss2Img.onload = this.ss2OnLoad;

      let iconPath = "";
      if (this.data.iconPath != null) iconPath = this.data.iconPath;
      else iconPath = require("@/assets/icon.png");
      const iconImg = new Image();
      iconImg.src = iconPath;
      iconImg.onload = this.iconOnLoad;
    }
  }
  
  ssBaseWidth = 250;
  ssBaseHeight = 450;
  iconBaseSize = 125;
  _ss1OnLoad(e: any) {
    const template = this.currentTemplate();
    if (this.previewContext == null || this.hiddenContext == null || template == null) return;

    let w = this.ssBaseWidth * this.previewScale * template.ss1Scale;
    let h = this.ssBaseHeight * this.previewScale * template.ss1Scale;
    this.previewContext.drawImage(e.target, template.ss1Left * this.previewScale - w/2, template.ss1Top * this.previewScale - h/2, w, h);

    w = this.ssBaseWidth * template.ss1Scale;
    h = this.ssBaseHeight * template.ss1Scale;
    this.hiddenContext.drawImage(e.target, template.ss1Left - w/2, template.ss1Top - h/2, w, h);
  }
  ss1OnLoad = this._ss1OnLoad.bind(this);
  _ss2OnLoad(e: any) {
    const template = this.currentTemplate();
    if (this.previewContext == null || this.hiddenContext == null || template == null) return;

    let w = this.ssBaseWidth * this.previewScale * template.ss2Scale;
    let h = this.ssBaseHeight * this.previewScale * template.ss2Scale;
    this.previewContext.drawImage(e.target, template.ss2Left * this.previewScale - w/2, template.ss2Top * this.previewScale - h/2, w, h);

    w = this.ssBaseWidth * template.ss2Scale;
    h = this.ssBaseHeight * template.ss2Scale;
    this.hiddenContext.drawImage(e.target, template.ss2Left - w/2, template.ss2Top - h/2, w, h);
  }
  ss2OnLoad = this._ss2OnLoad.bind(this);
  _iconOnLoad(e: any) {
    const template = this.currentTemplate();
    if (this.previewContext == null || this.hiddenContext == null || template == null) return;

    let w = this.iconBaseSize * this.previewScale * template.iconScale;
    let h = this.iconBaseSize * this.previewScale * template.iconScale;
    this.previewContext.drawImage(e.target, template.iconLeft * this.previewScale - w/2, template.iconTop * this.previewScale - h/2, w, h);
    
    w = this.iconBaseSize * template.iconScale;
    h = this.iconBaseSize * template.iconScale;
    this.hiddenContext.drawImage(e.target, template.iconLeft - w/2, template.iconTop - h/2, w, h);
  }
  iconOnLoad = this._iconOnLoad.bind(this);

  download() {
    const a = document.getElementById("downloadLink") as HTMLAnchorElement;
    a.href = this.hiddenCanvas?.toDataURL() as string;
    a.click();
  }

  tSampler: any;
  private currentTemplate(): any {
    // return this.tSampler;
    return Foregrounds.find(it => it.key == this.data.foregroundKey);
  }
  changeTSampler(s: any) {
    // this.tSampler = s;
  }

  cSampler: any;
  private currentColorSet(): any {
    // return this.cSampler;
    return ColorSets.find(it => it.key == this.data.colorSetKey);
  }
  changeCSampler(s: any) {
    // this.cSampler = s;
  }
}
